import BulmaTagsInput from '@creativebulma/bulma-tagsinput';
import '@creativebulma/bulma-tagsinput/dist/js/bulma-tagsinput.js'

document.addEventListener("DOMContentLoaded", () => {
  BulmaTagsInput.attach();
});